
export enum MetadataEntityFieldType {
    _Action_ = '_Action_',

    Date = 'Date',

    /** @deprecated use date and specify in editor options */
    DateTime = 'DateTime',

    /** @deprecated use date and specify in editor options */
    Time = 'Time',

    String = 'String',

    /** @deprecated use string and specify in editor options */
    StringAlphaNumeric = 'StringAlphaNumeric',

    /** @deprecated use string and specify in editor options */
    StringAlpha = 'StringAlpha',

    /** @deprecated use string and specify in editor options */
    Phone = 'Phone',

    /** @deprecated use string and specify in editor options */
    Email = 'Email',

    /** @deprecated use string and specify in editor options */
    Url = 'Url',

    Boolean = 'Boolean',
    Flag = 'Flag',

    Number = 'Number',

    /** @deprecated use number and specify in editor options */
    Percentage = 'Percentage',

    /** @deprecated use number and specify in editor options */
    Currency = 'Currency',

    Site = 'Site',
    Address = 'Address',
    Attachment = 'Attachment',
    EmbeddedEntity = 'EmbeddedEntity',

    Enum = 'Enum',
    Lookup = 'Lookup',
    Tag = 'Tag',
    Parent = 'Parent',

    CustomFields = 'CustomFields',
    CustomField = 'CustomField',

    Image = 'Image',
    QR = 'QR',

    Format = 'Format',

    Duration = 'Duration',

    EntityStatus = 'EntityStatus',

    CustomFieldDropdown = 'CustomFieldDropdown',

    Calculated = 'Calculated',

    None = 'None',

    Custom = 'Custom',
    Link = 'Link',
}

export type MetadataEntityField<T = MetadataEntityFieldType> = T | [T];


export enum MetadataEntityFieldEditorType {
    Dropdown = 'Dropdown',
    AutoComplete = 'AutoComplete',
    Calendar = 'Date',
    Date = 'Date',
    RelativeDate = 'RelativeDate',
    Input = 'Input',
    TextArea = 'TextArea',
    RichText = 'RichText',
    MergeInput = 'MergeInput',
    RadioGroup = 'RadioGroup',
    CheckboxGroup = 'CheckboxGroup',
    ButtonSelect = 'ButtonSelect',
    Number = 'Number',
    Switch = 'Switch',
    EntityPicker = 'EntityPicker',
    Address = 'Address',
    Label = 'Label',
    Custom = 'Custom',
}

